import React from "react";
import style from "../Assets/css/jobpostingpage.module.css";
import Switch from "react-switch";
import { useState } from "react";

const JobPostingLeftComp = (props) => {
	function HandleChange() {
		setchange(!change);
	}

	const {
		change,
		setchange,
		roles,
		selected,
		setSelected,
		platform,
		locationArr,
		Onelocation,
		setOnelocation,
		sortResults,
		fullTime,
		setFulltime,
		sortby,
		setsortby,
	} = props;

	return (
		<div
			className={
				platform == "mobile"
					? "px-3 mb-4 "
					: " mx-5  ml-2  shadow-sm py-3 "
			}
			style={{ paddingLeft: "10%", borderRadius: "6px" }}
		>
			<label
				for="exampleFormControlSelect3 "
				className={style.job_list_hdsmall_J}
			>
				Job type
			</label>
			<select
				style={{ padding: "8px", fontSize: "0.8rem" }}
				value={fullTime}
				onChange={(e) => setFulltime(e.target.value)}
				className={style.select}
				id="exampleFormControlSelect3"
			>
				<option value="ALL">All</option>
				<option value="INTERN">Internship</option>
				<option value="FULL">Full Time</option>
			</select>
			<br />
			<label
				for="exampleFormControlSelect3 "
				className={style.job_list_hdsmall_J}
			>
				Sort By
			</label>
			<select
				id="sortBy"
				style={{ padding: "8px", fontSize: "0.8rem" }}
				onChange={(e) => {
					setsortby(e.target.value);
					sortResults();
				}}
				className={style.select}
				id="exampleFormControlSelect3"
			>
				<option value="none">None</option>
				<option value="latest">Latest</option>
				<option value="dueDate">Due Date</option>
			</select>
			<br />
			<label
				for="exampleFormControlSelect1 "
				className={style.job_list_hdsmall_J + " "}
			>
				Role{" "}
			</label>
			<select
				style={{ padding: "8px", fontSize: "0.8rem" }}
				value={selected}
				onChange={(e) => {
					return setSelected(e.target.value);
				}}
				className={style.select}
				id="exampleFormControlSelect1"
			>
				<option value="ALL">All</option>
				{roles.map((value, index) => {
					return (
						<option value={value} key={index}>
							{value}
						</option>
					);
				})}
			</select>
			<br />

			<label
				for="exampleFormControlSelect3 "
				className={style.job_list_hdsmall_J}
			>
				Location
			</label>
			<select
				style={{ padding: "8px", fontSize: "0.8rem" }}
				value={Onelocation}
				onChange={(e) => setOnelocation(e.target.value)}
				className={style.select}
				id="exampleFormControlSelect3"
			>
				<option value="ALL Location">All Locations</option>
				{locationArr.map((value, index) => {
					return (
						<option value={value} key={index}>
							{" "}
							{value}{" "}
						</option>
					);
				})}
			</select>

			<br />

			<div className="container row p-0">
				<div className="col-sm-3 p-0">
					{/* <Switch height="28" handleDiameter="26" checkedIcon={false} uncheckedIcon={false}  onChange={HandleChange} checked={change} /> */}

					<div
						className={style.outdiv + " shadow "}
						style={{ backgroundColor: change ? "#002D6F" : "grey" }}
						onClick={() => {
							setchange(!change);
						}}
					>
						<div
							onClick={() => {
								setchange(!change);
							}}
							style={{ left: change ? "50%" : "-2%" }}
							src="..."
							alt="..."
							class={" rounded-circle  " + style.circle}
						>
							{" "}
						</div>
					</div>
				</div>
				<div className="col-sm-9 p-0">
					<span
						className={
							style.job_list_hdsmall_J + " " + style.remote
						}
					>
						Remote
					</span>
				</div>
			</div>
			{/* <input type="checkbox" data-size="xs" data-offstyle="light" checked={false} data-toggle="toggle" data-on=" " data-off=" " /> 
                            <label className="mx-2" htmlFor="customSwitch1">Only Remote</label> */}

			<br />
			{/* { platform!=="mobile" && <div class={style.job_list_box_J + " my-3 pt-3 pb-2 px-3"} style={{ width: "80%" }}>
          <h4 class={style.job_list_box_hd_J}>Keep upto Date!</h4>
          <p class={style.job_list_box_p_J}>Get a daily email of all new jobs </p>
          <div class="form-group">
            <input type="email" className={style.select} />
          </div>
          <div class="form-check">
            <input type="checkbox" class={"form-check-input"} id="exampleCheck1" />
            <label class={"form-check-label " + style.job_list_box_lbl_J} for="exampleCheck1">I agree to our company privacy policy</label>
          </div>
          <button class={"btn p-2 my-2 " + style.job_list_box_button_J} >Get Notified!</button>
        </div>} */}
			<br />
		</div>
	);
};

export default JobPostingLeftComp;
